(function (root, factory) {
  const api = factory();

  if (typeof module === "object" && module.exports) {
    module.exports = api;
  }

  if (root) {
    root.VendeyDocumentos = api;
  }
})(typeof globalThis !== "undefined" ? globalThis : this, function () {
  function normalizarNumero(valor) {
    return String(valor == null ? "" : valor).replace(/\D/g, "").slice(0, 11);
  }

  function inferirTipoCliente(numero) {
    const longitud = normalizarNumero(numero).length;
    if (longitud === 8) return "01";
    if (longitud === 11) return "06";
    return "";
  }

  function validarComprobante(datos) {
    const tipoVenta = String(datos && datos.tipoVenta || "");
    const tipoCliente = String(datos && datos.tipoCliente || "");
    const numero = normalizarNumero(datos && datos.numero);
    const esDniValido = tipoCliente === "01" && numero.length === 8;
    const esRucValido = tipoCliente === "06" && numero.length === 11;

    if (tipoVenta === "01") {
      return {
        valido: esRucValido,
        mensaje: "Para factura selecciona RUC e ingresa 11 dígitos."
      };
    }

    if (tipoVenta === "03") {
      return {
        valido: esDniValido || esRucValido,
        mensaje: "Para boleta ingresa DNI (8 dígitos) o RUC (11 dígitos)."
      };
    }

    return {
      valido: esDniValido || esRucValido,
      mensaje: "Ingresa un DNI de 8 dígitos o un RUC de 11 dígitos."
    };
  }

  return {
    normalizarNumero,
    inferirTipoCliente,
    validarComprobante
  };
});
